// extracted by mini-css-extract-plugin
export var hidden = "_oo-1";
export var visible = "_oo-0";